type IsoDate = { toISO: () => string | null } | null | undefined;

export interface DeliveryDateEdits {
  datePromised?: IsoDate;
  dateDelivery?: IsoDate;
  dateExpected?: IsoDate;
}

export interface DeliveryDatesPayload {
  datePromised?: string;
  dateDelivery?: string;
  dateExpected?: string;
}

/**
 * Body for PATCH board-purchase/:id from the dates edited in a Materials
 * Delivery row. Only picked dates are sent; the crud PATCH leaves absent
 * keys alone, so the row no longer has to be read back before saving.
 */
export function buildDeliveryDatesPayload(
  edits: DeliveryDateEdits | undefined,
): DeliveryDatesPayload {
  const payload: DeliveryDatesPayload = {};
  if (!edits) return payload;

  const promised = edits.datePromised?.toISO();
  if (promised) payload.datePromised = promised;

  const delivery = edits.dateDelivery?.toISO();
  if (delivery) payload.dateDelivery = delivery;

  const expected = edits.dateExpected?.toISO();
  if (expected) payload.dateExpected = expected;

  return payload;
}
